// import React, { useState } from "react";
import moment from "moment-timezone";

const TimeZoneComponent = ({ selectedHour, setSelectedHour }) => {
    // Get all time zones
    const timezones = moment.tz.names();

    // Extract unique UTC hour offsets
    const timezoneHours = Array.from(
        new Set(
            timezones.map((timezone) => {
                const offsetMinutes = moment.tz(timezone).utcOffset();
                return offsetMinutes / 60; // Convert minutes to hours
            })
        )
    ).sort((a, b) => a - b); // Sort offsets numerically
    // console.log('timezoneHours');
    // console.log(timezoneHours);
    // State to manage selected hour
    // const [selectedHour, setSelectedHour] = useState("");

    // Handle change in dropdown
    const handleSelect = (event) => {
        setSelectedHour(event.target.value);
    };

    return (
        <div>
            <label htmlFor="timezone-dropdown" className="block mb-2 font-semibold text-gray-700">
                Seleccione TimeZone<span className="text-red-500">*</span>
            </label>
            <select
                id="timezone-dropdown"
                value={selectedHour}
                onChange={handleSelect}
                className="border rounded-md p-2 w-full"
            >
                <option value="">Seleccione opcion</option>
                {timezoneHours.map((hour) => (
                    <option key={hour} value={hour}>
                        UTC{hour >= 0 ? "+" : ""}
                        {hour}
                    </option>
                ))}
            </select>
            {/* {selectedHour && (
                <p className="mt-4 text-gray-700">
                    Selected Hour: UTC{selectedHour >= 0 ? "+" : ""}
                    {selectedHour}
                </p>
            )} */}
        </div>
    );
};

export default TimeZoneComponent;
